// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JlXH","left":"styles_left__37JfK","right":"styles_right__QCo8H","alert":"styles_alert__28NVX"};